/**
 * Makes a query event text string
 * @param {Object} options
 * @param {String} options.test - the data to test
 * @param {String} options.acknowledged - the data to mark verified
 * @returns {String} - Query Event
 */
const query = ({ test, acknowledged }) => {
  if (test) return `is-${test}`;
  if (acknowledged) return `${acknowledged}-acknowledged`;
};

module.exports = query;
